// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1656":"b30a8abe","6161":"c47c55d4","9787":"d684d24d"}[chunkId] + ".chunk.css";
};